import { render, staticRenderFns } from "./Assunto.vue?vue&type=template&id=39ec7bc5&scoped=true"
import script from "./Assunto.vue?vue&type=script&lang=ts"
export * from "./Assunto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec7bc5",
  null
  
)

export default component.exports